import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyStart: {
        id: 'policycommon.component.policy-common-details.Policy Effective',
        defaultMessage: 'Policy Effective'
    },
    PolicyExpiration: {
        id: 'policycommon.component.policy-common-details.Policy Expiration',
        defaultMessage: 'Policy Expiration'
    },
    PolicyType: {
        id: 'policycommon.component.policy-common-details.Policy Type',
        defaultMessage: 'Policy Type'
    },
    PolicyAddres: {
        id: 'policycommon.component.policy-common-details.Policy Address',
        defaultMessage: 'Policy Address'
    },
    TotalPremium: {
        id: 'policycommon.component.policy-common-details.Total Premium',
        defaultMessage: 'Total Premium'
    },
    TaxesAndFees: {
        id: 'policycommon.component.policy-common-details.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    TotalCost: {
        id: 'policycommon.component.policy-common-details.Total Cost',
        defaultMessage: 'Total Cost'
    },
    details: {
        id: 'policycommon.component.policy-common-details.Details',
        defaultMessage: 'Details'
    },
    premium: {
        id: 'policycommon.component.policy-common-details.Premium',
        defaultMessage: 'Premium'
    },
    cppPolicyContent: {
        id: 'policycommon.component.policy-common-details.cppPolicyContent',
        defaultMessage: 'Commercial Package Policy including '
    }
});
